up.compiler('body.bookmarklet', function(body) {
  body.querySelector('#head a, #tail a').setAttribute('target', '_blank')
})
